/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useLocation, matchPath, useHistory } from 'react-router';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  List,
  ListSubheader,
  makeStyles
} from '@material-ui/core';
// import {
//  mar
// } from '@material-ui/icons';
import {
  Search as SearchIcon,
  PieChart as PieChartIcon,
  Users as UsersIcon,
  Grid as GridIcon,
  Database as DatabaseIcon,
  PhoneCall as PhoneCallIcon,
  Heart as HeartIcon,
  Clock as ClockIncon,
  DollarSign as DollarSignIcon,
  HelpCircle as HelpCircleIcon,
  Server as ServerIcon,
  RefreshCw as RefreshCwIcon,
  Tag as TagIcon,
  CheckCircle as CheckCircleIcon,
  FileText as FileTextIcon,
  LogOut as LogOutIcon,
} from 'react-feather';
// import Logo from 'src/components/Logo';
import NavItem from './NavItem';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { logout } from 'src/actions/accountActions';
import { track } from 'src/utils/mixpanel';
import SignOutDialog from 'src/components/SignOutDialog';

const navConfig = [
  {
    subheader: '',
    items: [
      {
        title: 'Full Inventory',
        icon: GridIcon,
        href: '/app/solar-panels?terms=modules'
      },
      {
        title: 'Saved Products',
        icon: HeartIcon,
        href: '/app/solar-panels/favorites?terms=modules'
      },
      {
        title: 'Product Alerts',
        icon: ClockIncon,
        href: '/app/solar-panels/other-alerts?terms=modules'
      },
    ]
  },
  {
    subheader: '',
    items: [
      {
        title: 'Request a Product',
        icon: HelpCircleIcon,
        href: '/app/solar-panels/request-product'
      },
      {
        title: 'Offer Your Products',
        icon: DollarSignIcon,
        href: '/app/solar-panels/product-offer'
      },
    ]
  },
  {
    subheader: 'Reports',
    items: [
      {
        title: 'Admin Dashboard',
        icon: PieChartIcon,
        href: '/app/admin/interface/home'
      },
      {
        title: 'Hidden Data',
        icon: GridIcon,
        href: '/app/admin/hiddenData/list'
      }
    ]
  },
  {
    subheader: 'Management',
    items: [
      {
        title: 'Edit Products',
        icon: DatabaseIcon,
        href: '/app/admin/allproducts/list'
      },
      {
        title: 'Server Control',
        icon: ServerIcon,
        href: '/app/admin/server/control'
      },
      {
        title: 'Manage News',
        icon: FileTextIcon,
        href: '/app/admin/news/management'
      },
      {
        title: 'Edit Contacts',
        icon: PhoneCallIcon,
        href: '/app/admin/contact/list'
      },
      {
        title: 'Search Results',
        icon: SearchIcon,
        href: '/app/admin/saveSearch/results'
      },
      {
        title: 'Users',
        icon: UsersIcon,
        href: '/app/admin/customers/list',
        // items: [
        //   {
        //     title: 'List Users',
        //     href: '/app/management/customers'
        //   },
        //   {
        //     title: 'View Customer',
        //     href: '/app/management/customers/1'
        //   },
        //   {
        //     title: 'Edit Customer',
        //     href: '/app/management/customers/1/edit'
        //   }
        // ]
      }

    ]
  },
  {
    subheader: 'HubSpot',
    items: [
      {
        title: 'Sync Controls',
        icon: RefreshCwIcon,
        href: '/app/admin/hubspot/controls'
      },
      {
        title: 'Tag Management',
        icon: TagIcon,
        href: '/app/admin/hubspot/tags'
      },
      {
        title: 'Approvals',
        icon: CheckCircleIcon,
        href: '/app/admin/hubspot/product-changes'
      }
    ]
  }
];
const navConfigCustomer = [
  {
    subheader: '',
    items: [
      {
        title: 'Full Inventory',
        icon: GridIcon,
        href: '/app/solar-panels?terms=modules'
      },
      {
        title: 'Saved Products',
        icon: HeartIcon,
        href: '/app/solar-panels/favorites?terms=modules'
      },
      {
        title: 'Product Alerts',
        icon: ClockIncon,
        href: '/app/solar-panels/other-alerts?terms=modules'
      },
    ]
  },
  {
    subheader: '',
    items: [
      {
        title: 'Request a Product',
        icon: HelpCircleIcon,
        href: '/app/solar-panels/request-product'
      },
      {
        title: 'Offer Your Products',
        icon: DollarSignIcon,
        href: '/app/solar-panels/product-offer'
      },
    ]
  },
];

const publicNavItems = [
  { title: 'Home', href: '/home' },
  { title: 'About Us', href: '/about-us' },
  { title: 'News', href: '/app/solar-panels/news' },
  { title: 'Events', href: '/app/solar-panels/events' },
  { title: 'Re+ 2026', href: '/re-plus-las-vegas-2026' },
  { title: 'Safe Harbor', href: '/safe-harbor' },
  { title: 'Custom Procurement', href: '/custom-procurement' },
  { title: 'Contact Us', href: '/contact' },
];

function renderNavItems({ items, ...rest }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, ...rest }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({
  acc,
  pathname,
  item,
  depth = 0
}) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={key}
        info={item.info}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={key}
        info={item.info}
        title={item.title}
      />
    );
  }

  return acc;
}

const useStyles = makeStyles((theme) => ({
  mobileDrawer: {
    width: 200,
    backgroundColor: '#1F242D',
    color: '#ffffff',
  },
  desktopDrawer: {
    width: 200,
    // top: 0,
    // height: '100%'
  },
  avatar: {
    width: 130,
    height: 130,
    padding: 5,
    boxSizing: 'border-box',
    borderRadius: '50%',
    backgroundColor: "#1c2025",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  avatarSquare: {
    width: 200,
    height: 200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarImage: {
    width: '91%',
    height: '91%',
    objectFit: 'contain',
    display: 'block',
    cursor: 'pointer',
  },
  logoutSection: {
    padding: theme.spacing(1),
    paddingTop: 0,
  },
  logoutButton: {
    color: theme.palette.text.secondary,
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium,
    minWidth: 0,
  },
  logoutIcon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    // Match previous inventory header: LogOut rotated 180deg.
    transform: 'rotate(180deg)',
  },
  logoutTitle: {
    marginRight: 'auto',
  },
  publicNavDivider: {
    height: 1,
    margin: theme.spacing(0.5, 1, 1),
    backgroundColor: 'rgba(255, 255, 255, 0.28)',
  },
  publicNavMobileOnly: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  publicNavList: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  publicNavButton: {
    width: '100%',
    padding: '10px 8px',
    color: 'rgba(255, 255, 255, 0.78)',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    fontWeight: theme.typography.fontWeightMedium,
  },
  publicNavButtonActive: {
    color: '#009eda',
  },
}));

function NavBar({ openMobile, onMobileClose, includePublicNav }) {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const account = useSelector((state) => state.account);
  const [exitModal, setExitModal] = useState(false);
  const accountNavConfig = account.user.role === "admin"
    ? navConfig
    : navConfigCustomer;

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const handleLogout = async () => {
    try {
      setExitModal(false);
      if (onMobileClose) {
        onMobileClose();
      }
      track('User Logged Out', {
        pageUrl: window.location.href,
        userState: account.user ? 'Logged In' : 'Logged Out',
      });
      await dispatch(logout());
      history.push('/app/solar-panels');
    } catch (error) {
      enqueueSnackbar('Unable to logout', {
        variant: 'error',
      });
    }
  };

  const handlePublicNavigate = (href) => {
    if (onMobileClose) {
      onMobileClose();
    }
    if (href.startsWith('/app/')) {
      history.push(href);
      return;
    }
    window.location.href = href;
  };

  const content = (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Box display='flex' justifyContent='center'>
          <Box
            className={classes.avatarSquare}
            onClick={() => history.push('/app/solar-panels')}
            role="button"
            aria-label="Go to inventory"
            style={{ cursor: 'pointer' }}
          >
            <Avatar className={classes.avatar}>
              <img
                src="/static/1000containers-logo-white.svg"
                alt="1000 Containers"
                className={classes.avatarImage}
              />
            </Avatar>
          </Box>
        </Box>
        <Divider />
        <Box p={1}>
          {accountNavConfig.map((config, index) => (
            <React.Fragment key={config.items[0].title}>
              <List
                subheader={(
                  <ListSubheader
                    disableGutters
                    disableSticky
                  >
                    {config.subheader}
                  </ListSubheader>
                )}
              >
                {renderNavItems({ items: config.items, pathname: location.pathname })}
              </List>
              {includePublicNav && index === 1 ? (
                <Box className={classes.publicNavMobileOnly}>
                  <Divider className={classes.publicNavDivider} />
                  <List className={classes.publicNavList} disablePadding>
                    {publicNavItems.map((item) => (
                      <Button
                        key={item.title}
                        className={clsx(
                          classes.publicNavButton,
                          location.pathname === item.href && classes.publicNavButtonActive,
                        )}
                        onClick={() => handlePublicNavigate(item.href)}
                      >
                        {item.title}
                      </Button>
                    ))}
                  </List>
                </Box>
              ) : null}
            </React.Fragment>
          ))}
        </Box>
        <Divider />
        <Box className={classes.logoutSection}>
          <Button
            className={classes.logoutButton}
            onClick={() => setExitModal(true)}
            aria-label="Log out"
          >
            <LogOutIcon className={classes.logoutIcon} size={20} />
            <span className={classes.logoutTitle}>Log out</span>
          </Button>
        </Box>
      </PerfectScrollbar>
      <SignOutDialog
        open={exitModal}
        onClose={() => setExitModal(false)}
        onConfirm={handleLogout}
      />
    </Box>
  );

  return (
    <>
      {/* <Hidden lgUp> */}
      <Drawer
        anchor="right"
        classes={{ paper: classes.mobileDrawer }}
        onClose={onMobileClose}
        open={openMobile}
        variant="temporary"
      >
        {content}
      </Drawer>
      {/* </Hidden> */}
      {/* <Hidden mdDown>
        <Drawer
          anchor="right"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden> */}
    </>
  );
}

NavBar.propTypes = {
  includePublicNav: PropTypes.bool,
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
